import React from 'react'
import { useStateValue } from '../context/StateProvider';
import { getOrders } from '../utils/firebaseFunctions';
import OrderDetail from './OrderDetail';

const Order = () => {
    const [{foodItems,orders,user}, dispatch] = useStateValue();
    

  return (
    <div>
        <h2>MY ORDERS</h2>
        <div className="overflow-x-scroll scrollbar-none w-full shadow-md sm:rounded-lg">
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        <th scope="col" className="py-3 px-6">
                            ORDER ID
                        </th>
                        <th scope="col" className="py-3 px-6">
                            STATUS
                        </th>
                        <th scope="col" className="py-3 px-6">
                            DATE
                        </th>
                        <th scope="col" className="py-3 px-6">
                            Total <span className=" text-[10px] text-red-400">(with delivery charges)</span>
                        </th>
                        <th scope="col" className="py-3 px-6">
                            ACTION
                        </th>
                    </tr>
                </thead>
                
                    <OrderDetail  data={orders?.filter(n=>n.uid ===user.uid)}/>
                    
            </table>
        </div>
        
    </div>
  )
}

export default Order